import { useState as F, useEffect as O, useMemo as re } from "react";
import { A as v, m as C, C as R, W as f, l as ne } from "./colors-cfab1b7b.js";
var p = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, ie = typeof p == "object" && p && p.Object === Object && p, oe = ie, ae = oe, se = typeof self == "object" && self && self.Object === Object && self, ce = ae || se || Function("return this")(), z = ce, ue = z, fe = ue.Symbol, I = fe;
function de(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var le = de, be = Array.isArray, me = be, W = I, B = Object.prototype, ge = B.hasOwnProperty, Te = B.toString, T = W ? W.toStringTag : void 0;
function ye(e) {
  var t = ge.call(e, T), r = e[T];
  try {
    e[T] = void 0;
    var n = !0;
  } catch (s) {
  }
  var i = Te.call(e);
  return n && (t ? e[T] = r : delete e[T]), i;
}
var he = ye, pe = Object.prototype, ve = pe.toString;
function Se(e) {
  return ve.call(e);
}
var Ae = Se, L = I, _e = he, Ee = Ae, Oe = "[object Null]", Ie = "[object Undefined]", M = L ? L.toStringTag : void 0;
function we(e) {
  return e == null ? e === void 0 ? Ie : Oe : M && M in Object(e) ? _e(e) : Ee(e);
}
var Ne = we;
function $e(e) {
  return e != null && typeof e == "object";
}
var je = $e, xe = Ne, Ce = je, Re = "[object Symbol]";
function We(e) {
  return typeof e == "symbol" || Ce(e) && xe(e) == Re;
}
var q = We, k = I, Le = le, Me = me, ke = q, Ge = 1 / 0, G = k ? k.prototype : void 0, P = G ? G.toString : void 0;
function V(e) {
  if (typeof e == "string")
    return e;
  if (Me(e))
    return Le(e, V) + "";
  if (ke(e))
    return P ? P.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Ge ? "-0" : t;
}
var Pe = V, He = Pe;
function Ue(e) {
  return e == null ? "" : He(e);
}
var Ye = Ue, De = Ye, Fe = 0;
function ze(e) {
  var t = ++Fe;
  return De(e) + t;
}
var Be = ze;
const Nt = () => {
  const [e] = F(Be("player"));
  return e;
};
function qe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var J = qe, Ve = /\s/;
function Je(e) {
  for (var t = e.length; t-- && Ve.test(e.charAt(t)); )
    ;
  return t;
}
var Qe = Je, Xe = Qe, Ke = /^\s+/;
function Ze(e) {
  return e && e.slice(0, Xe(e) + 1).replace(Ke, "");
}
var et = Ze, tt = et, H = J, rt = q, U = 0 / 0, nt = /^[-+]0x[0-9a-f]+$/i, it = /^0b[01]+$/i, ot = /^0o[0-7]+$/i, at = parseInt;
function st(e) {
  if (typeof e == "number")
    return e;
  if (rt(e))
    return U;
  if (H(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = H(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = tt(e);
  var r = it.test(e);
  return r || ot.test(e) ? at(e.slice(2), r ? 2 : 8) : nt.test(e) ? U : +e;
}
var Q = st, ct = Q, Y = 1 / 0, ut = 17976931348623157e292;
function ft(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = ct(e), e === Y || e === -Y) {
    var t = e < 0 ? -1 : 1;
    return t * ut;
  }
  return e === e ? e : 0;
}
var $t = ft, dt = z, lt = function() {
  return dt.Date.now();
}, bt = lt, mt = J, E = bt, D = Q, gt = "Expected a function", Tt = Math.max, yt = Math.min;
function ht(e, t, r) {
  var n, i, s, u, a, c, l = 0, N = !1, m = !1, S = !0;
  if (typeof e != "function")
    throw new TypeError(gt);
  t = D(t) || 0, mt(r) && (N = !!r.leading, m = "maxWait" in r, s = m ? Tt(D(r.maxWait) || 0, t) : s, S = "trailing" in r ? !!r.trailing : S);
  function A(o) {
    var d = n, g = i;
    return n = i = void 0, l = o, u = e.apply(g, d), u;
  }
  function K(o) {
    return l = o, a = setTimeout(h, t), N ? A(o) : u;
  }
  function Z(o) {
    var d = o - c, g = o - l, x = t - d;
    return m ? yt(x, s - g) : x;
  }
  function $(o) {
    var d = o - c, g = o - l;
    return c === void 0 || d >= t || d < 0 || m && g >= s;
  }
  function h() {
    var o = E();
    if ($(o))
      return j(o);
    a = setTimeout(h, Z(o));
  }
  function j(o) {
    return a = void 0, S && n ? A(o) : (n = i = void 0, u);
  }
  function ee() {
    a !== void 0 && clearTimeout(a), l = 0, n = c = i = a = void 0;
  }
  function te() {
    return a === void 0 ? u : j(E());
  }
  function _() {
    var o = E(), d = $(o);
    if (n = arguments, i = this, c = o, d) {
      if (a === void 0)
        return K(c);
      if (m)
        return clearTimeout(a), a = setTimeout(h, t), A(c);
    }
    return a === void 0 && (a = setTimeout(h, t)), u;
  }
  return _.cancel = ee, _.flush = te, _;
}
var pt = ht;
function jt() {
  const [e, t] = F({
    width: window.innerWidth,
    height: window.innerHeight
  }), r = Number(e == null ? void 0 : e.width) <= 960, n = Number(e == null ? void 0 : e.width) <= 500;
  return O(() => {
    const i = pt(
      () => t({
        width: window.innerWidth,
        height: window.innerHeight
      }),
      50
    );
    return window.addEventListener("resize", i), i(), () => {
      window.removeEventListener("resize", i);
    };
  }, []), { windowSize: e, isTabletWindowSize: r, isPhoneWindowSize: n };
}
var y = {}, vt = {
  get exports() {
    return y;
  },
  set exports(e) {
    y = e;
  }
};
vt.exports = w;
y.isMobile = w;
y.default = w;
const St = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, At = /CrOS/, _t = /android|ipad|playbook|silk/i;
function w(e) {
  e || (e = {});
  let t = e.ua;
  if (!t && typeof navigator != "undefined" && (t = navigator.userAgent), t && t.headers && typeof t.headers["user-agent"] == "string" && (t = t.headers["user-agent"]), typeof t != "string")
    return !1;
  let r = St.test(t) && !At.test(t) || !!e.tablet && _t.test(t);
  return !r && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && t.indexOf("Macintosh") !== -1 && t.indexOf("Safari") !== -1 && (r = !0), r;
}
var Et = /* @__PURE__ */ ((e) => (e.WATCH = "WATCH", e.TRAILER = "TRAILER", e.UPGRADE_TO_WATCH = "UPGRADE_TO_WATCH", e.SIGN_IN_TO_WATCH = "SIGN_IN_TO_WATCH", e))(Et || {});
const xt = () => y({ featureDetect: !0, tablet: !0 }), Ot = (e, t) => e ? t.some((r) => r === e.type) : !1, X = (e) => e && Ot(e, [v.LIVE_CHANNEL, v.LIVE_EVENT]), Ct = (e) => X(e) && "live" in e && !!e.live, Rt = (e, t) => {
  if (!e)
    return;
  if (e.type === v.SHOW && t) {
    const n = e != null && e.children ? e == null ? void 0 : e.children.find((s) => s.id === t) : void 0, i = n && C(n, R.TRAILER);
    if (i)
      return {
        asset: n,
        content: i
      };
  }
  const r = C(e, R.TRAILER);
  if (r)
    return {
      asset: e,
      content: r
    };
}, Wt = (e, t) => (e == null ? void 0 : e.watchable) === f.NO_CONTENT && !!t, Lt = (e, t) => {
  switch (e == null ? void 0 : e.watchable) {
    case f.YES:
    case f.YES_ANONYMOUS_ACCESS:
      return "WATCH";
    case f.NO_CONTENT:
      return null;
    case f.PLAN_UPGRADE_REQUIRED:
      return t ? "SIGN_IN_TO_WATCH" : "UPGRADE_TO_WATCH";
    default:
      return null;
  }
}, Mt = (e, t) => {
  var i;
  if (!e)
    return;
  const r = t ? "square" : "jumbotron", n = t ? "512x512" : "1280x720";
  return `${(i = ne(e, r)) == null ? void 0 : i.url}_${n}`;
}, kt = (e) => {
  var t, r, n, i;
  return !!(e.crew.length || e.year || (t = e.moods) != null && t.length || (r = e.genres) != null && r.length || (n = e.censorships) != null && n.minAge || (i = e.appropriatenessTags) != null && i.length);
}, Gt = (e, t) => e.watchable && ![
  f.PLAN_UPGRADE_REQUIRED,
  f.YES,
  f.YES_ANONYMOUS_ACCESS
].includes(e.watchable) || t && e.watchable !== f.YES_ANONYMOUS_ACCESS, Pt = ({
  asset: e,
  isFinished: t,
  lastWatchedEpisodeDetails: r
}) => {
  const n = X(e);
  return { assetWithContent: re(() => {
    var u, a, c;
    if (!e)
      return;
    if (e.type === v.MOVIE || n)
      return e;
    if (r && !t)
      return r;
    const s = (c = (a = (u = e.children) == null ? void 0 : u.find((l) => l.order === 1)) == null ? void 0 : a.children) == null ? void 0 : c[0];
    return s || e;
  }, [e, n, r, t]) };
}, b = "data-modal-styles", Ht = (e, t) => {
  O(() => {
    if (document.getElementById(b))
      return;
    const r = document.createElement("style");
    r.setAttribute("type", "text/css"), r.setAttribute("id", b), r.innerHTML = `
            body[${b}] {
                overflow: hidden;
                position: fixed;
            }
        `, document.head.appendChild(r);
  }, []), O(() => (e ? document.body.setAttribute(b, t) : document.body.removeAttribute(b), () => {
    document.body.removeAttribute(b);
  }), [t, e]);
};
export {
  Et as B,
  Ne as _,
  oe as a,
  Pe as b,
  J as c,
  Ye as d,
  jt as e,
  Ct as f,
  z as g,
  me as h,
  je as i,
  I as j,
  q as k,
  Lt as l,
  X as m,
  Mt as n,
  xt as o,
  Ht as p,
  Gt as q,
  Pt as r,
  kt as s,
  $t as t,
  Nt as u,
  Rt as v,
  Ot as w,
  Wt as x,
  Q as y,
  pt as z
};
//# sourceMappingURL=useModalStyles-de8d2ca8.js.map
